/* eslint-disable import/no-unresolved */
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ContentfulContext } from '../../context/Contentful';
import { useMemo } from 'react/cjs/react.production.min';
import styled from '@emotion/styled';
import BlogItemGrid from '../../components/BlogItemGrid';
import { useBrandDetails } from 'dw-au-react-components';
import Banner from '../LandingPage/Banner';
import { Link, useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import Pagination from '../../components/pagination';
import { Helmet } from 'react-helmet';

const Section = styled.section`
	margin-left: auto;
	margin-right: auto;
	padding: 30px 15px 15px;
	width: 100%;
	@media (min-width: 992px) {
		max-width: 970px;
	}
	@media (min-width: 768px) and (max-width: 991px) {
		max-width: 720px;
	}
	@media (min-width: 576px) and (max-width: 768px) {
		max-width: 540px;
	}
	.blog_title {
		font-size: 40px;
		font-weight: 500;
		line-height: 52px;
		text-align: left;
	}
	.blog-wrapper {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: 40px 20px;
		padding: 54px 0 30px 0;

		@media screen and (max-width: 767px) {
			grid-template-columns: 1fr;
			padding: 0;
		}

		.empty-results {
			grid-column-start: 2;

			@media screen and (max-width: 767px) {
				grid-column-start: auto;
			}
		}
	}
	.breadcrums {
		display: flex;
		border-bottom: 1px solid #a0a0a0;
		margin-bottom: 20px;
		p {
			color: #a0a0a0;
			font-size: 16px;
			font-weight: 400;
			line-height: 24px;
			text-align: center;
			padding-right: 10px;
		}
		.active {
			&:hover {
				text-decoration: underline;
			}
		}
	}
`;

const CategoryBlogs = () => {
	const initialPaginationDetails = {
		itemsPerPage: '',
		totalItems: '',
		totalPages: '',
		firstItem: '',
		lastItem: '',
		activeCards: [],
		current: '',
		prev: '',
		next: ''
	};
	const [paginationDetails, setPaginationDetails] = useState(
		initialPaginationDetails
	);
	const history = useHistory();
	let { category } = useParams();
	const { blogLandingData, blogConfigData } = useContext(ContentfulContext);
	const brandDetails = useBrandDetails();
	const pageparam = parseInt(history?.location?.search.replace('?page=', ''));
	const [pageNo, setPageNo] = useState(pageparam || 1);
	const paginationCount = 9;

	const totalCards = useMemo(() => {
		const data = blogLandingData?.filter((a) => a.blogCategory === category);
		return data?.length;
	}, [category, blogLandingData]);

	useEffect(() => {
		const list = blogLandingData?.filter((a) => a.blogCategory === category);
		if (paginationCount) {
			let itemsPerPage = paginationCount;
			let totalItems = list?.length;
			let totalPages = Math?.ceil(totalItems / itemsPerPage);
			let firstItem = (pageNo - 1) * itemsPerPage;
			let lastItem = firstItem + itemsPerPage;

			let activeCards = list?.slice(firstItem, lastItem);
			let current = pageNo;
			let prev = pageNo === 1 ? true : false;
			let next = pageNo === totalPages ? true : false;

			setPaginationDetails({
				itemsPerPage,
				totalItems,
				totalPages,
				firstItem,
				lastItem,
				activeCards,
				current,
				prev,
				next
			});
		} else {
			setPaginationDetails({ activeCards: list });
		}
	}, [pageNo, category, blogLandingData]);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const blogCategory = useMemo(() => {
		return blogConfigData?.blogCategories?.items.find(
			(a) => a.title === category
		);
	}, [blogConfigData, category]);

	const updatePageNo = (buttonDir) => {
		switch (buttonDir) {
			case 'next':
				setPageNo(pageNo + 1);
				history.push(`?page=${pageNo + 1}`);
				window.scrollTo(0, 400);
				break;
			case 'prev':
				setPageNo(pageNo - 1);
				history.push(`${`?page=${pageNo - 1}`}`);
				window.scrollTo(0, 400);
				break;
			default: {
				setPageNo(buttonDir);
				window.scrollTo(0, 400);
			}
		}
	};

	return (
		<div>
			<Helmet>
				<title>
					{blogConfigData?.metaTitle} - {category}
				</title>
				<link rel='canonical' href={location?.href}></link>
			</Helmet>
			<Banner
				brandDetails={brandDetails}
				config={blogConfigData}
				url={blogCategory?.banner || '/images/au/common/blog/wpe_bg_banner.png'}
				marginBottom={5}
				backgroudPosition={blogCategory?.banner ? 'center' : 'right'}
			/>
			<Section>
				<div className='breadcrums'>
					<Link to='/blog'>
						<p className='active'>Blog Home</p>
					</Link>
					<p>/</p>
					<p>{blogCategory?.title}</p>
				</div>
				<div>
					<h1 className='blog_title'>{blogCategory?.title}</h1>
					<p>{blogCategory?.description}</p>
				</div>
				<div className='blog-wrapper'>
					{paginationDetails?.activeCards?.map((item, index) => {
						return (
							<BlogItemGrid
								key={index}
								blogItem={item}
								brandDetails={brandDetails}
								category={category}
							/>
						);
					})}
				</div>
				{!isNaN(paginationCount) &&
					paginationCount &&
					paginationDetails?.activeCards?.length > 0 &&
					totalCards > 9 && (
						<Pagination
							current={paginationDetails?.current}
							total={paginationDetails?.totalPages}
							next={paginationDetails?.next}
							prev={paginationDetails?.prev}
							updatePageNo={updatePageNo}
						/>
					)}
				{(!paginationDetails?.activeCards ||
					paginationDetails?.activeCards?.length === 0) && (
					<div className='alert alert-info m-20'>No blog items found.</div>
				)}
			</Section>
		</div>
	);
};

export default CategoryBlogs;
